export const RECORD_CHANGED_EVENT = 'buildout:record-changed';

// Elasticsearch makes a write searchable about a second after it reaches the index.
const INDEX_DELAY_MS = 1000;

export interface ChangedParent {
  type: string;
  id: number;
}

type Change =
  | { kind: 'activity_created'; id: number; parent: ChangedParent }
  | { kind: 'task_created'; id: number; parent: ChangedParent }
  | { kind: 'task_updated'; id: number; parent: ChangedParent }
  | { kind: 'task_deleted'; id: number; parent: ChangedParent }
  | { kind: 'contact_created'; id: number }
  | { kind: 'contact_updated'; id: number }
  | { kind: 'contact_list_created'; id: number }
  | { kind: 'contact_list_contacts_added'; id: number };

export type RecordChangeKind = Change['kind'];

// `retry` marks the repeat, so a list that already had its answer from the database can ignore it
export type RecordChange = Change & { retry?: boolean };

// The kinds a list reads back out of Elasticsearch.
const SEARCHED_KINDS: RecordChangeKind[] = ['activity_created', 'task_created', 'task_updated', 'task_deleted'];

export const recordChanged = (change: Change) => {
  if (typeof window === 'undefined') return;

  const dispatch = (detail: RecordChange) => (
    window.dispatchEvent(new CustomEvent(RECORD_CHANGED_EVENT, { detail }))
  );

  dispatch(change);

  if (SEARCHED_KINDS.includes(change.kind)) {
    setTimeout(() => dispatch({ ...change, retry: true }), INDEX_DELAY_MS);
  }
};
